import axiosInstance from '../utils/AxiosConfig';

class AchievementsService {
  async getAchievements() {
    try {
      console.log('[AchievementsService] GET /achievements - Request');
      const response = await axiosInstance.get('/achievements');
      console.log('[AchievementsService] GET /achievements - Response:', response.data);
      return response.data.data || [];
    } catch (error) {
      console.error('[AchievementsService] GET /achievements - Error:', error);
      console.error('[AchievementsService] GET /achievements - Error Response:', error.response?.data);
      throw error;
    }
  }

  async getAchievementById(id) {
    try {
      console.log(`[AchievementsService] GET /achievements/${id} - Request`);
      const response = await axiosInstance.get(`/achievements/${id}`);
      console.log(`[AchievementsService] GET /achievements/${id} - Response:`, response.data);
      return response.data.data;
    } catch (error) {
      console.error(`[AchievementsService] GET /achievements/${id} - Error:`, error);
      console.error(`[AchievementsService] GET /achievements/${id} - Error Response:`, error.response?.data);
      throw error;
    }
  }

  async createAchievement(achievement) {
    try {
      const requestData = {
        name: achievement.name,
        description: achievement.description,
        category: achievement.category,
        icon_type: achievement.icon_type,
        is_active: achievement.is_active !== undefined ? achievement.is_active : true
      };
      
      // Incluir default_requirement_value solo si tiene un valor (no null, no undefined)
      if (achievement.default_requirement_value !== null && achievement.default_requirement_value !== undefined) {
        requestData.default_requirement_value = achievement.default_requirement_value;
      }
      
      console.log('[AchievementsService] POST /achievements - Request:', requestData);
      const response = await axiosInstance.post('/achievements', requestData);
      console.log('[AchievementsService] POST /achievements - Response:', response.data);
      return response.data.data;
    } catch (error) {
      console.error('[AchievementsService] POST /achievements - Error:', error);
      console.error('[AchievementsService] POST /achievements - Error Response:', error.response?.data);
      throw error;
    }
  }

  async updateAchievement(id, achievement) {
    try {
      const requestData = {
        name: achievement.name,
        description: achievement.description,
        category: achievement.category,
        icon_type: achievement.icon_type,
        is_active: achievement.is_active
      };
      
      // Incluir default_requirement_value solo si tiene un valor (no null, no undefined)
      if (achievement.default_requirement_value !== null && achievement.default_requirement_value !== undefined) {
        requestData.default_requirement_value = achievement.default_requirement_value;
      }
      
      console.log(`[AchievementsService] PUT /achievements/${id} - Request:`, requestData);
      const response = await axiosInstance.put(`/achievements/${id}`, requestData);
      console.log(`[AchievementsService] PUT /achievements/${id} - Response:`, response.data);
      return response.data.data;
    } catch (error) {
      console.error(`[AchievementsService] PUT /achievements/${id} - Error:`, error);
      console.error(`[AchievementsService] PUT /achievements/${id} - Error Response:`, error.response?.data);
      throw error;
    }
  }

  async deleteAchievement(id) {
    try {
      console.log(`[AchievementsService] DELETE /achievements/${id} - Request`);
      const response = await axiosInstance.delete(`/achievements/${id}`);
      console.log(`[AchievementsService] DELETE /achievements/${id} - Response:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`[AchievementsService] DELETE /achievements/${id} - Error:`, error);
      console.error(`[AchievementsService] DELETE /achievements/${id} - Error Response:`, error.response?.data);
      throw error;
    }
  }

  // Asignaciones de logros
  async getAchievementAssignments(achievementId) {
    try {
      console.log(`[AchievementsService] GET /achievements/${achievementId}/assignments - Request`);
      const response = await axiosInstance.get(`/achievements/${achievementId}/assignments`);
      console.log(`[AchievementsService] GET /achievements/${achievementId}/assignments - Response:`, response.data);
      return response.data.data || [];
    } catch (error) {
      console.error(`[AchievementsService] GET /achievements/${achievementId}/assignments - Error:`, error);
      console.error(`[AchievementsService] GET /achievements/${achievementId}/assignments - Error Response:`, error.response?.data);
      throw error;
    }
  }

  async assignAchievement(assignment) {
    try {
      const requestData = {
        achievement_id: assignment.achievement_id,
        scope: assignment.scope,
        branch_id: assignment.branch_id,
        user_id: assignment.user_id,
        month: assignment.month,
        year: assignment.year,
        requirement_value: assignment.requirement_value
      };
      console.log('[AchievementsService] POST /achievements/assignments - Request:', requestData);
      const response = await axiosInstance.post('/achievements/assignments', requestData);
      console.log('[AchievementsService] POST /achievements/assignments - Response:', response.data);
      return response.data.data;
    } catch (error) {
      console.error('[AchievementsService] POST /achievements/assignments - Error:', error);
      console.error('[AchievementsService] POST /achievements/assignments - Error Response:', error.response?.data);
      throw error;
    }
  }

  async deleteAchievementAssignment(assignmentId) {
    try {
      console.log(`[AchievementsService] DELETE /achievements/assignments/${assignmentId} - Request`);
      const response = await axiosInstance.delete(`/achievements/assignments/${assignmentId}`);
      console.log(`[AchievementsService] DELETE /achievements/assignments/${assignmentId} - Response:`, response.data);
      return response.data;
    } catch (error) {
      console.error(`[AchievementsService] DELETE /achievements/assignments/${assignmentId} - Error:`, error);
      console.error(`[AchievementsService] DELETE /achievements/assignments/${assignmentId} - Error Response:`, error.response?.data);
      throw error;
    }
  }
}

export default new AchievementsService();

